<template>
  <a-row :gutter="20" class="connect-to-church">
    <a-col>
      <a-card :title="$t('cardTitle.connectToChurch')" class="style3 text-center">
        <a slot="extra" href="javascript://" style="color: white" @click="isViewExample = true">View Example</a>
        <template v-if="isConnected">
          <div>
            <span style="margin-right: 2px; color: #212b36">Your request is waiting to be approved by {{ connectedChurchName }}!</span>
            <br />
            <a-button type="primary" class="tf-btn-primary" style="margin-top: 15px" @click="e => disconnectChurchConnection()"> Disconnect </a-button>
          </div>
        </template>
        <template v-else>
          <div v-if="!user.user.story" data-show="true" class="ant-alert ant-alert-error ant-alert-no-icon ant-alert-closable" style="margin-bottom: 1rem">
            <span class="ant-alert-message">
              You must film your Jesus Story before you can submit a Connect Request to attach your story to the church.
              <a href="/share-your-story">Click here</a>
            </span>
          </div>
          <div class="connecting-box" v-if="user.user.story">
            <p style="text-align: center">
              Connect your Jesus story to your church by searching our database.
              <br />
              <a style="color: #1c84c6; text-decoration: underline" @click="showChurchForm">If you don’t see your church</a> listed, please enter your churches contact information to help us notify
              your pastor.
              <br />
              If you don’t have your church’s information, check out their website or give them a call.
            </p>
            <div style="max-width: 720px; margin: 0 auto">
              <a-input-search placeholder="City & State... or Zip Code..." enter-button="Search" size="large" @search="onSearch" />

              <a-table
                :columns="columns"
                :data-source="churchList"
                :showHeader="false"
                :locale="{
                  emptyText: 'Unfortunately, Your church is not registered with TrueLife.org yet. \n\r Please enter your church contact information.',
                }"
                rowKey="id"
                style="margin-top: 1rem"
                class="no-attempts"
              >
                <a slot="name" slot-scope="text, record">
                  <span v-text="record.name" style="color: #1c84c6" @click="e => fillForm(record)" />
                  <span v-text="` - ${record.city} ${record.state}`" />
                </a>
                <span slot="action" slot-scope="text, record">
                  <a-button type="primary tf-primary tf-btn-primary" style="min-width: 100px" @click="e => connectToChurch(record)"> Connect </a-button>
                </span>
              </a-table>
              <br />
              <a-form
                v-if="isSubmitFormVisible"
                :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }"
                :hideRequiredMark="true"
                @submit="handleSubmit"
                id="churchConnectForm"
                style="margin-top: 2rem"
              >
                <a-form-item label="Church Name">
                  <a-input
                    v-decorator="[
                      'churchname',
                      {
                        rules: [{ required: true, message: 'Church Name can not blank!' }],
                      },
                    ]"
                    placeholder="Church Name"
                  />
                </a-form-item>
                <a-form-item label="Pastor Name">
                  <a-input
                    v-decorator="[
                      'pastorname',
                      {
                        rules: [{ required: true, message: 'Pastor Name can not blank!' }],
                      },
                    ]"
                    placeholder="Pastor Name"
                  />
                </a-form-item>
                <a-form-item label="Pastor Email">
                  <a-input
                    v-decorator="[
                      'pastoremail',
                      {
                        rules: [{ required: true, message: 'Pastor email can not blank!' }],
                      },
                    ]"
                    placeholder="Pastor Email"
                  />
                </a-form-item>
                <a-form-item label="Church Number">
                  <a-input v-decorator="['churchnumber']" placeholder="Church Number" />
                </a-form-item>
                <a-form-item label="Church Website">
                  <a-input v-decorator="['churchwebsite']" placeholder="Church Website" />
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24, offset: 0 }" :style="{ textAlign: 'center' }">
                  <a-spin tip="Sending connect request ..." :spinning="isConnecting" size="large">
                    <div class="spin-content">
                      <a-button type="primary" class="tf-btn tf-btn-primary" style="width: 180px" html-type="submit"> Submit </a-button>
                    </div>
                  </a-spin>
                </a-form-item>
              </a-form>
            </div>
          </div>
          <a-row>
            <a-col v-if="searchAttempt">
              <a style="color: #1c84c6; text-decoration: underline" @click="showChurchForm">Click here if you don't see your church</a>
            </a-col>
          </a-row>
        </template>

        <a-modal title="" centered :footer="null" :visible="isConnectionSent" :closable="false">
          <div style="text-align: center">
            <p>
              We have sent your connect request to <span style="color: #1c84c6">{{ selectedChurch.name }}</span> successfully. You will get emailed when the pastor approves or declines this request.
            </p>
            <a-button
              type="primary"
              @click="
                e => {
                  isConnectionSent = false;
                }
              "
            >
              OK
            </a-button>
          </div>
        </a-modal>
        <a-modal title="" centered :footer="null" :visible="isCreationSent" :closable="false">
          <div style="text-align: center">
            <p>
              Thank you for the information. We have sent an email to your pastor and also emailed you an email to forward to your pastor. You can still use your Jesus Story while we are waiting for
              your church to connect.
              <br />
              You will be notified once your Jesus Story is approved.
              <br />
              You are all done for now!
            </p>
            <a-button
              type="primary"
              @click="
                e => {
                  isCreationSent = false;
                }
              "
            >
              OK
            </a-button>
          </div>
        </a-modal>
        <a-modal title="" centered :footer="null" :visible="isMultiAttempt" :closable="false">
          <div style="text-align: center">
            <p>
              Your account is already connected to the church <span style="color: #1c84c6">{{ selectedChurch.name }}</span
              >.
            </p>
            <a-button
              type="primary"
              @click="
                e => {
                  isMultiAttempt = false;
                }
              "
            >
              OK
            </a-button>
          </div>
        </a-modal>
        <a-modal title="" centered :footer="null" :visible="isViewExample" :closable="false" :width="1024">
          <div style="text-align: center">
            <a-row :gutter="20" style="margin-top: 2rem; margin-bottom: 2rem">
              <a-col :md="{ span: 20, offset: 2 }" :lg="{ span: 22, offset: 1 }">
                <h3>
                  <strong>
                    Now that your video is under review we need you to connect your church, as you can see in the image provided. Please search for your church and if you do not see your church
                    provide us with the details so we can call your church and get them connected.
                  </strong>
                </h3>
              </a-col>
              <a-col :md="{ span: 20, offset: 2 }" :lg="{ span: 22, offset: 1 }">
                <img :src="require('../../assets/images/church_connect_thomasroad.jpg')" style="margin-top: 1rem; width: 100%" />
              </a-col>
            </a-row>
            <a-button
              type="primary"
              @click="
                e => {
                  isViewExample = false;
                }
              "
            >
              OK
            </a-button>
          </div>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { mapState } from 'vuex';
import store from '@/store';
import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';

export default {
  data() {
    return {
      isConnecting: false,
      churchList: [],
      selectedChurch: {},
      isConnectionSent: false,
      isCreationSent: false,
      isSubmitFormVisible: false,
      isMultiAttempt: false,
      searchAttempt: false,
      isViewExample: false,
      isConnected: false,
      connectedChurchName: '',
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'Action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ],
      form: this.$form.createForm(this, { name: 'form' }),
    };
  },
  computed: {
    ...mapState(['user']),
    connectedChurch() {
      return store.state.user.user.churchName || ['review', 'approved'].includes(store.state.user.user.churchStatus);
    },
  },
  mounted() {
    this.isConnected = store.state.user.user.churchName || ['review', 'approved'].includes(store.state.user.user.churchStatus);
    this.connectedChurchName = store.state.user.user.churchName;
  },
  methods: {
    async onSearch(value) {
      this.churchList = await LocationService.getNearby(value);
      this.searchAttempt = true;
      this.isSubmitFormVisible = false;
    },
    fillForm(record) {
      this.searchAttempt = false;
      this.isSubmitFormVisible = true;
      const formData = {
        churchname: record.name,
        pastorname: record.pastor.name,
        pastoremail: record.pastor.email,
        churchnumber: record.pastor.phone,
      };
      this.form.setFieldsValue(formData);
      let elmnt = document.getElementById('churchConnectForm');
      elmnt.scrollIntoView({ behavior: 'smooth' });
    },
    async connectToChurch(record) {
      if (this.selectedChurch.name) {
        this.isMultiAttempt = true;
        return;
      }

      const { email } = store.state.user.user;
      /* eslint-disable camelcase */
      const { account_id, id } = record;

      const resp = await UserService.doUpdateUser({
        email,
        account_id,
        location_id: id,
        church_status: 'review',
      });
      store.dispatch('updateUser', {
        user: {
          ...store.state.user.user,
          churchStatus: resp.church_status,
          accountId: resp.account_id,
          churchName: record.name,
        },
      });
      this.isConnected = true;
      this.connectedChurchName = record.name;
      this.isSubmitFormVisible = false;
      this.selectedChurch = record;
      this.isConnectionSent = true;
    },
    async disconnectChurchConnection() {
      await UserService.doDisconnectChurchConnect({
        id: store.state.user.user.userId,
      });

      store.dispatch('updateUser', {
        user: {
          ...store.state.user.user,
          churchStatus: null,
          accountId: null,
          churchName: '',
        },
      });
      this.isConnected = false;
      this.connectedChurchName = '';
      this.selectedChurch = {};
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isConnecting = true;
            const resp = await UserService.doRequestChurchCreation(values);
            store.dispatch('updateUser', {
              user: {
                ...store.state.user.user,
                churchStatus: resp.data.status,
                accountId: resp.data.account_id,
                churchName: resp.data.church_name,
              },
            });
            this.isConnected = true;
            this.connectedChurchName = resp.data.church_name;
            this.isConnecting = false;
          } catch (e) {
            console.log(e);
          }
          this.isCreationSent = true;
          this.isSubmitFormVisible = false;
        }
      });
    },
    showChurchForm() {
      this.searchAttempt = false;
      this.isSubmitFormVisible = true;
      this.churchList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.connect-to-church-container.content-page {
  padding: 0 !important;
  .connect-to-church {
    padding: 20px;
    .ant-btn {
      white-space: initial;
    }
  }

  .ant-card-head-title {
    text-align: center !important;
  }
}
/deep/ .ant-table-placeholder {
  white-space: break-spaces !important;
  color: #212b36 !important;
}

/deep/ .no-attempts .ant-table-placeholder {
  display: none !important;
}

/deep/ .ant-input-search .ant-input-search-button {
  background-color: #1c84c6 !important;
  border: none !important;
}
</style>
